import React, { useEffect, useState } from 'react'
import { Button, Message } from '../EventNotFound';
import { EEventTypeId } from 'src/util/utilModel';
import styled from 'styled-components';
import Intl from "src/components/common/Intl"
import { withAppContext } from 'src/store/initAppContext';
import { useNavigate, useParams } from 'react-router-dom';
import Icon, { IconWrapper } from 'src/components/common/PNGIcon';
import config from 'src/config/config';
import { Floatbtn, GameIconBlue, GameIconGreen, GameInfo, GameName, GameTittleSection, HeaderSection, SEOMetaInnerMarket } from './new-game-details';
import { theme } from 'styled-tools';

export interface Selection {
  name: string;
  selectionId: number;
}

export interface Market {
  marketId: number;
  marketName: string;
  status: 'OPENED' | 'CLOSED' | 'SUSPENDED'; 
  marketStartTime?: any; 
  list: Selection[];
}

export interface SEOEventProps {
  categoryId: number;
  categoryName: string;
  competitionId: number;
  competitionName: string;
  eventId: number;
  eventName: string;
  marketStartTime?: any; // Or Date if you plan to transform it
  snk: Market[];
}

const getData = async (url: string) => {
    try {
        const resp = await fetch(url, { cache: 'force-cache' })
        if (!resp.ok) {
            throw new Error(`Response status: ${resp.status}`);
        }

        const respJson = await resp.json();
        return respJson;

    } catch (error) {
        console.error(error.Message);

    }

    return {}

}

function NoEventDataComponent(props: any) {
    const param = useParams();
    let navigate = useNavigate();
    const { id, competitionId, eventId, } = param;
    let _category = EEventTypeId[id] || 0;
    const [seoObjects, setseoObjects] = useState({} as SEOEventProps);
    const [showNoEvent, setShowNoEvent] = useState(false)
    const [teamName, setTeamName] = useState('')

    useEffect(() => {
        const url = `${config.cmsAPI}/marketInfoSeo?categoryId=${_category}&competitionId=${competitionId}&eventId=${eventId}`;

        const _getData = getData(url);
        _getData.then(res => {
            const resIsArray = Array.isArray(res);
            if (resIsArray) {
                setShowNoEvent(true)
                //No Data
            }
            else {
                const {eventName} = res
                setseoObjects(res);
                setTeamName(eventName)
            }

        }).catch(err => {
            console.log('Issue in fetching Data', err)
            setShowNoEvent(true)
        })
    }, []);

    const backButton = () => {
        navigate(`/betting-exchange/${id}`);
    }



    const {marketStartTime,competitionName,snk} = seoObjects;
     let matchName = "";
     let marketName = "";
     let StartTime:any = marketStartTime ? new Date(marketStartTime).toDateString() : "";
     if(snk && snk[0]?.list){
         matchName = `${snk[0]?.list[0]?.name} vs ${snk[0]?.list[1]?.name}`;
         marketName = snk[0].marketName;
         StartTime = snk[0].marketStartTime ? new Date(snk[0].marketStartTime).toDateString() : StartTime;
     }

    return showNoEvent ? (
        <Wrapper>
            <Content>
                <Message theme={props.app.theme}><Intl langKey="TABLE@NO_EVENT" /></Message>

                <Button onClick={() => navigate('/')}>
                    <Intl langKey="EVENTS@GOTO_HOME" /><Icon name="chevron-right-light" />
                </Button>

            </Content>
        </Wrapper>
    ) : (<>
        <SEOMetaInnerMarket params={param} metaData={seoObjects} />
        <HeaderSection>
            <GameTittleSection>
                <Floatbtn>
                    <button onClick={backButton}>
                        <Intl langKey="BUTTON@BACK" />
                    </button>
                </Floatbtn>
                <GameInfo>
                    <GameIconBlue></GameIconBlue>
                    <GameName>{teamName}</GameName>
                    <GameIconGreen></GameIconGreen>
                </GameInfo>
            </GameTittleSection>
        </HeaderSection>
        <EventBody>
            <h2>Review:</h2>

           <p> <Label>Match Date:</Label> {StartTime}</p>
            <p>  <Label>Match:</Label> {matchName}</p> 
            <p> <Label>Competition:</Label> {competitionName}</p>
            <p><Label>Market:</Label> {marketName}</p>
            

            <OptionalMSG>Live score information is currently unavailable. Odds and betting market updates continue to be displayed.</OptionalMSG>


        </EventBody>
    </>)
}

export default withAppContext(NoEventDataComponent);

//styled Component
const Content = styled.div`
	display: flex;
	flex-direction: column;
	margin-bottom: 8em;
	align-items: center;
	padding-top:100px;
	
`;
const Wrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	width: 100%;
	height: 100%;
`;
const EventBody = styled.div`
    display: flex;
    margin-top: 10px;
    flex-direction:column;
    padding: 30px;
    background: ${theme('palette.gameTittleSectionBG')};
    /* background: #161515fc; */
    border-radius: 5px;
     color: #d4c6c6;
    h2 {
        padding: 0;
        margin-top: 0;
    }
    p {
        margin: 0;
        padding: 5px 0;
       
    }
`;
const Label = styled.span`
    font-weight: 700;
`;

const OptionalMSG = styled.div`
    padding: 5px 0;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 15px;
    font-size: 18px;
    color: #fff;
    font-style: italic;
`
